export default {
      id: "wave-usage",
      viewBox: "0 0 72 53",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#wave",
      toString: function () {
        return this.url;
      }
    }